import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import {
  CompanyDetailType,
  getCompanyDetailEndpoint,
} from 'repositories/BerthApi/getCompanyDetail/endpoint'
import type { GetCompanyDetailResponse } from 'repositories/BerthApi/getCompanyDetail/type'
import { companyKeys } from 'repositories/queryKeys'

type UseCompanyDetailParams = {
  tenantId: string | null
  warehouseId: string | null
  companyId: string | null
  type: CompanyDetailType
}

export function useCompanyDetail({
  tenantId,
  warehouseId,
  companyId,
  type,
}: UseCompanyDetailParams) {
  const isEnabled = !!tenantId && !!warehouseId && !!companyId

  // Note: enabled=false のとき v4 の isLoading は true のまま残るため、
  // 実際にフェッチ中かを示す isInitialLoading (= isLoading && isFetching) を使う。
  const { data, isInitialLoading } = useQuery<GetCompanyDetailResponse>({
    queryKey: companyKeys.detail(tenantId ?? '', warehouseId ?? '', companyId ?? '', type),
    queryFn: () =>
      fetcher(
        getCompanyDetailEndpoint({
          tenantId: tenantId!,
          warehouseId: warehouseId!,
          companyId: companyId!,
          type,
        })
      ),
    enabled: isEnabled,
  })

  return {
    companyDetail: data?.data ?? null,
    isLoading: isInitialLoading,
  }
}
